package com.essntl.features.dashboard.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ColumnScope.DashboardHeader(
    modifier: Modifier = Modifier,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.SectionVerticalPadding,
                horizontal = EsConstants.SectionHorizontalPadding,
            ),
    ) {
        Text(
            text = "My Essentials",
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.h2Bold32,
        )
    }
}